require('./angular-animate');
module.exports = 'ngAnimate';



//////////////////
// WEBPACK FOOTER
// ./~/angular-animate/index.js
// module id = 1325
// module chunks = 2